import React, { Component } from 'react'
import BackgroundImage from 'gatsby-background-image'
import * as styles from './index.module.css'
import Link from '../Link'

export default class BackgroundImageCallout extends Component {
  render() {
    var props = this.props

    return (
      <BackgroundImage
        className={styles.imageContainer}
        image={props.images[0].gatsbyImageData}
      >
        <div className="wrapper">
          <div className={styles.container}>
            <h2>{props.title}</h2>
            {props.subtitle != null && <span>{props.subtitle.subtitle}</span>}
            <div
              className={
                this.props.components.length > 1
                  ? styles.multiple
                  : styles.single
              }
            >
              {this.props.components.map((link, idx) => (
                <Link to={link.ctaUrl} key={idx}>
                  {link.ctaText}
                </Link>
              ))}
            </div>
          </div>
        </div>
      </BackgroundImage>
    )
  }
}
